import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { MuiButton } from "@ryde/controls";
import { systemSettingsDtoAtom } from "@ryde/shared";

import { FormFooterStyled } from "../../drawer/form-footer.styled";

interface IBulkCreateBookingFooterProps {
  onSaveClick: () => void;
  onCancelClick: () => void;
  isLoading: boolean;
  saveLabel?: string;
  isSaveDisabled: boolean;
  cancelLabel?: string;
  /** Left out by panels that edit bookings rather than create them - there is nothing to produce. */
  isProduceButtonActive?: boolean;
  onProduce?: () => void;
}

export const BulkCreateBookingFooter: FC<IBulkCreateBookingFooterProps> = ({
  onSaveClick,
  onCancelClick,
  isLoading = false,
  saveLabel,
  isSaveDisabled,
  cancelLabel,
  isProduceButtonActive,
  onProduce,
}) => {
  const { t } = useTranslation();
  const systemSettingsDto = useRecoilValue(systemSettingsDtoAtom);
  const { hideProduceButtonAfterBooking } = systemSettingsDto?.metadata ?? {};

  return (
    <FormFooterStyled>
      <MuiButton
        e2eData={`cancel_button_right_footer_${cancelLabel || ""}`}
        muiVariant="outlined"
        color="secondary"
        onClick={onCancelClick}
        loading={isLoading}
      >
        {cancelLabel || t(`general.CANCEL`)}
      </MuiButton>

      {Boolean(isProduceButtonActive && !hideProduceButtonAfterBooking) && (
        <MuiButton
          e2eData={`produce_these_bookings_button_${saveLabel || ""}`}
          disabled={!isProduceButtonActive}
          onClick={onProduce}
          muiStyle="secondary"
        >
          {t(`booking.bulk.produceTheseBookings`)}
        </MuiButton>
      )}
      {Boolean(onSaveClick) && (
        <MuiButton
          e2eData={`save_button_right_footer_${saveLabel || ""}`}
          loading={isLoading}
          muiStyle={isSaveDisabled ? "error" : "primary"}
          disabled={isSaveDisabled}
          onClick={onSaveClick}
        >
          {saveLabel || t(`general.SAVE`)}
        </MuiButton>
      )}
    </FormFooterStyled>
  );
};
